import script from "./TableTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableTitle.vue?vue&type=script&lang=ts&setup=true"

import "./TableTitle.vue?vue&type=style&index=0&id=74019f96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74019f96"]])

export default __exports__